import { atom } from 'jotai'

import { type BrandGroup } from '~/gql/graphql'

export const brandGroupIdAtom = atom<BrandGroup['id'] | null>(null)
